(function () {
    'use strict';
    // #updateProductStock
    // add to the skuOverrides object to hide out of stock products from upsell
    // OOS_SKU_REPLACEMENTS: {
    //     'CP-UA-CS': { substituteWith: 'CP-UA-CV' },
    // },
    const BASE_RECOMMENDATION = 'CP-UA-CV';
    const OOS_SKU_REPLACEMENTS = {
        // 'CP-UA': { substituteWith: 'CP-UA-FP' },
        // 'CP-UA-CS': { substituteWith: 'CP-UA-FP' },
        // 'CP-UA-FF': { substituteWith: 'CP-UA-FP' },
        // 'CP-UA-FP': { substituteWith: 'CP-UA-FP' },
        // 'CP-UA-LC': { substituteWith: 'CP-UA-FP' },
        // 'CP-UA-MB': { substituteWith: 'CP-UA-FP' },
        // 'CP-UA-RW': { substituteWith: 'CP-UA-FP' },
        // 'CP-UA-SP': { substituteWith: 'CP-UA-FP' },
        // 'CP-UA-SW': { substituteWith: 'CP-UA-FP' },
        // 'CP-CU-KITC': { substituteWith: 'CP-CU-KITM' },
        // 'CP-CU-AC': { substituteWith: 'CP-CU-AM' },
        // 'CP-CE-1': { substituteWith: 'CP-UA-CL' },
        'CP-12M': { substituteWith: 'CP-14' },
    }

    const UA_PRODUCT_ID_AB_TEST = 4996364566661;

    const SCENT_RECOMMENDATIONS = {
        scentPicks: {
            'CP-UA-FP': ['CP-UA-CV', 'CP-UA-CL', 'CP-UA-MB', 'CP-UA-RW', 'CP-UA-SW', 'CP-UA-OS', 'CP-UA-LC', 'CP-UA-VP', 'CP-UA-FF'],
            'CP-UA-LC': ['CP-UA-CV', 'CP-UA-CL', 'CP-UA-RW', 'CP-UA-FP', 'CP-UA-MB', 'CP-UA-SW', 'CP-UA-VP', 'CP-UA-OS', 'CP-UA-FF'],
            'CP-UA-SW': ['CP-UA-MB', 'CP-UA-CL', 'CP-UA-OS', 'CP-UA-FP', 'CP-UA-CV', 'CP-UA-RW', 'CP-UA-LC', 'CP-UA-VP', 'CP-UA-FF'],
            'CP-UA-MB': ['CP-UA-CL', 'CP-UA-SW', 'CP-UA-OS', 'CP-UA-FP', 'CP-UA-CV', 'CP-UA-RW', 'CP-UA-LC', 'CP-UA-VP', 'CP-UA-FF'],
            'CP-UA-CV': ['CP-UA-FP', 'CP-UA-CL', 'CP-UA-SW', 'CP-UA-RW', 'CP-UA-MB', 'CP-UA-VP', 'CP-UA-OS', 'CP-UA-LC', 'CP-UA-FF'],
            'CP-UA-CL': ['CP-UA-MB', 'CP-UA-FP', 'CP-UA-OS', 'CP-UA-SW', 'CP-UA-CV', 'CP-UA-RW', 'CP-UA-LC', 'CP-UA-VP', 'CP-UA-FF'],
            'CP-UA-FF': ['CP-UA-CV', 'CP-UA-FP', 'CP-UA-CL', 'CP-UA-OS', 'CP-UA-MB', 'CP-UA-RW', 'CP-UA-SW', 'CP-UA-VP', 'CP-UA-LC'],
            'CP-UA-RW': ['CP-UA-CV', 'CP-UA-FP', 'CP-UA-CL', 'CP-UA-LC', 'CP-UA-MB', 'CP-UA-SW', 'CP-UA-VP', 'CP-UA-OS', 'CP-UA-FF'],
            'CP-UA-OS': ['CP-UA-MB', 'CP-UA-CL', 'CP-UA-SW', 'CP-UA-FP', 'CP-UA-CV', 'CP-UA-RW', 'CP-UA-LC', 'CP-UA-VP', 'CP-UA-FF'],
            'CP-UA-VP': ['CP-UA-CV', 'CP-UA-RW', 'CP-UA-CL', 'CP-UA-FP', 'CP-UA-LC', 'CP-UA-SW', 'CP-UA-OS', 'CP-UA-MB', 'CP-UA-FF'],
        },
        pairPicks: {
            'CP-UA-CL|CP-UA-CV': 'CP-UA-FP',
            'CP-UA-CL|CP-UA-FF': 'CP-UA-FP',
            'CP-UA-CL|CP-UA-FP': 'CP-UA-MB',
            'CP-UA-CL|CP-UA-LC': 'CP-UA-FP',
            'CP-UA-CL|CP-UA-MB': 'CP-UA-OS',
            'CP-UA-CL|CP-UA-OS': 'CP-UA-MB',
            'CP-UA-CL|CP-UA-RW': 'CP-UA-CV',
            'CP-UA-CL|CP-UA-SW': 'CP-UA-MB',
            'CP-UA-CL|CP-UA-VP': 'CP-UA-CV',
            'CP-UA-CV|CP-UA-FF': 'CP-UA-FP',
            'CP-UA-CV|CP-UA-FP': 'CP-UA-CL',
            'CP-UA-CV|CP-UA-LC': 'CP-UA-RW',
            'CP-UA-CV|CP-UA-MB': 'CP-UA-SW',
            'CP-UA-CV|CP-UA-OS': 'CP-UA-MB',
            'CP-UA-CV|CP-UA-RW': 'CP-UA-FP',
            'CP-UA-CV|CP-UA-SW': 'CP-UA-MB',
            'CP-UA-CV|CP-UA-VP': 'CP-UA-RW',
            'CP-UA-FF|CP-UA-FP': 'CP-UA-CV',
            'CP-UA-FF|CP-UA-MB': 'CP-UA-CL',
            'CP-UA-FF|CP-UA-OS': 'CP-UA-CL',
            'CP-UA-FF|CP-UA-RW': 'CP-UA-CV',
            'CP-UA-FF|CP-UA-SW': 'CP-UA-CL',
            'CP-UA-FF|CP-UA-VP': 'CP-UA-CV',
            'CP-UA-FP|CP-UA-LC': 'CP-UA-CV',
            'CP-UA-FP|CP-UA-MB': 'CP-UA-CL',
            'CP-UA-FP|CP-UA-OS': 'CP-UA-CL',
            'CP-UA-FP|CP-UA-RW': 'CP-UA-CV',
            'CP-UA-FP|CP-UA-SW': 'CP-UA-CL',
            'CP-UA-FP|CP-UA-VP': 'CP-UA-CV',
            'CP-UA-LC|CP-UA-MB': 'CP-UA-CL',
            'CP-UA-LC|CP-UA-OS': 'CP-UA-CL',
            'CP-UA-LC|CP-UA-RW': 'CP-UA-CV',
            'CP-UA-LC|CP-UA-SW': 'CP-UA-CV',
            'CP-UA-LC|CP-UA-VP': 'CP-UA-CV',
            'CP-UA-MB|CP-UA-OS': 'CP-UA-CL',
            'CP-UA-MB|CP-UA-RW': 'CP-UA-CL',
            'CP-UA-MB|CP-UA-SW': 'CP-UA-CL',
            'CP-UA-MB|CP-UA-VP': 'CP-UA-CV',
            'CP-UA-OS|CP-UA-RW': 'CP-UA-CL',
            'CP-UA-OS|CP-UA-SW': 'CP-UA-MB',
            'CP-UA-OS|CP-UA-VP': 'CP-UA-CV',
            'CP-UA-RW|CP-UA-SW': 'CP-UA-FP',
            'CP-UA-RW|CP-UA-VP': 'CP-UA-CV',
            'CP-UA-SW|CP-UA-VP': 'CP-UA-CV',
        },
    };

    const CART_UPSELL_DATA = {
        baseRecommendation: BASE_RECOMMENDATION,
        skuOverrides: OOS_SKU_REPLACEMENTS,
        scentRecommendations: SCENT_RECOMMENDATIONS,
        skuMatrix: {
            'CP-01': [408, 172, 20, 78, 16, 13, 21, 6, 7, 19, 30, 8, 77, 6, 9, 36, 0, 19, 11, 12, 21],
            'CP-02': [179, 345, 21, 86, 27, 15, 36, 10, 9, 27, 31, 9, 78, 6, 9, 40, 0, 18, 12, 13, 20],
            'CP-10-15': [37, 36, 309, 60, 38, 23, 50, 13, 24, 30, 70, 39, 82, 10, 13, 56, 0, 30, 18, 23, 28],
            'CP-11': [33, 35, 14, 431, 36, 11, 78, 15, 49, 125, 17, 5, 59, 4, 5, 30, 0, 13, 7, 7, 17],
            'CP-12F': [23, 38, 30, 122, 309, 8, 119, 33, 21, 73, 39, 16, 41, 5, 7, 43, 0, 15, 15, 10, 24],
            'CP-12M': [48, 53, 48, 99, 20, 324, 55, 16, 25, 49, 41, 20, 49, 3, 6, 36, 0, 37, 3, 37, 19],
            'CP-13': [20, 32, 25, 169, 75, 13, 327, 30, 28, 89, 28, 9, 45, 4, 6, 36, 0, 14, 11, 9, 21],
            'CP-14': [24, 35, 27, 127, 84, 16, 120, 293, 25, 70, 35, 4, 43, 5, 6, 32, 0, 11, 9, 7, 17],
            'CP-16-15': [15, 19, 27, 237, 29, 14, 64, 14, 336, 124, 13, 3, 28, 3, 4, 22, 0, 12, 5, 7, 14],
            'CP-16-2': [59, 54, 49, 228, 73, 30, 108, 24, 26, 139, 5, 30, 53, 5, 4, 36, 0, 23, 12, 18, 13],
            'CP-17': [15, 21, 13, 236, 40, 10, 78, 15, 48, 377, 19, 4, 48, 2, 4, 22, 0, 9, 6, 6, 15],
            'CP-CE-1': [47, 45, 59, 64, 42, 17, 48, 15, 10, 37, 324, 31, 71, 11, 11, 55, 1, 33, 21, 25, 24],
            'CP-CU-AC': [46, 29, 71, 77, 81, 17, 57, 33, 26, 32, 180, 26, 65, 23, 29, 80, 1, 26, 26, 38, 27],
            'CP-CU-AM': [39, 51, 58, 102, 60, 25, 66, 37, 34, 61, 147, 15, 87, 15, 11, 70, 2, 35, 14, 26, 33],
            'CP-CU-KITC': [39, 40, 97, 56, 50, 25, 44, 5, 8, 27, 92, 422, 25, 4, 3, 24, 0, 11, 7, 6, 7],
            'CP-CU-KITM': [63, 77, 150, 103, 100, 27, 93, 18, 22, 56, 110, 20, 40, 17, 10, 21, 1, 12, 21, 10, 22],
            'CP-CU-W': [36, 34, 71, 78, 81, 25, 57, 27, 38, 51, 145, 17, 85, 13, 19, 87, 0, 37, 21, 36, 32],
            'CP-UA': [52, 51, 30, 94, 19, 9, 33, 8, 9, 41, 31, 3, 461, 10, 12, 47, 0, 32, 12, 15, 22],
            'CP-UA-CS': [25, 26, 23, 41, 17, 4, 20, 6, 6, 12, 30, 3, 62, 421, 17, 79, 2, 67, 48, 32, 48],
            'CP-UA-FF': [36, 36, 29, 53, 21, 7, 25, 6, 9, 19, 29, 2, 70, 15, 484, 51, 0, 29, 19, 20, 28],
            'CP-UA-FP': [34, 36, 29, 66, 28, 9, 37, 8, 10, 26, 33, 5, 67, 17, 12, 434, 0, 52, 21, 24, 39],
            'CP-UA-LC': [16, 33, 29, 48, 24, 3, 33, 7, 9, 31, 39, 3, 29, 29, 1, 48, 460, 33, 54, 26, 31],
            'CP-UA-MB': [29, 27, 26, 48, 16, 16, 25, 5, 9, 19, 34, 3, 75, 24, 11, 85, 0, 402, 27, 63, 44],
            'CP-UA-RW': [32, 32, 28, 48, 29, 2, 32, 6, 6, 20, 37, 4, 48, 31, 13, 61, 2, 48, 433, 31, 45],
            'CP-UA-SP': [34, 33, 30, 80, 44, 10, 49, 10, 16, 34, 37, 5, 59, 72, 17, 99, 2, 88, 73, 84, 114],
            'CP-UA-SW': [29, 31, 31, 45, 17, 25, 24, 4, 9, 19, 40, 3, 55, 19, 13, 63, 1, 99, 28, 388, 47],
            'CP-UA-V': [36, 33, 26, 72, 28, 9, 39, 8, 12, 31, 27, 2, 57, 19, 12, 71, 0, 48, 28, 33, 398],
            'CP-P3U': [17, 17, 22, 24, 8, 6, 18, 5, 3, 12, 29, 6, 280, 40, 31, 148, 1, 128, 38, 89, 67],
            'CP-P3U-FP': [15, 36, 36, 31, 25, 5, 15, 0, 0, 5, 31, 0, 207, 62, 5, 227, 0, 124, 67, 62, 41],
            'CP-P3F': [41, 51, 31, 143, 41, 12, 83, 31, 76, 194, 19, 9, 76, 9, 22, 60, 3, 22, 25, 3, 38],
            'CP-P24': [20, 20, 26, 160, 89, 13, 106, 29, 69, 170, 35, 4, 76, 17, 23, 47, 0, 13, 27, 9, 37],
            'CP-P10': [8, 14, 21, 246, 31, 5, 50, 9, 43, 66, 21, 3, 263, 19, 20, 48, 0, 31, 37, 20, 36],
            'CP-P2': [68, 0, 26, 131, 38, 26, 76, 15, 32, 32, 35, 6, 165, 30, 39, 78, 1, 88, 44, 27, 35],
            'CP-P28': [12, 28, 12, 231, 34, 6, 63, 9, 37, 224, 18, 6, 205, 3, 9, 37, 3, 3, 9, 15, 25],
            'CP-P3U-MB': [22, 26, 20, 48, 18, 13, 20, 9, 3, 9, 28, 1, 106, 18, 11, 59, 0, 473, 31, 41, 33],
            'CP-P4': [181, 173, 24, 34, 24, 8, 28, 7, 10, 13, 35, 4, 208, 30, 23, 54, 1, 48, 42, 17, 26],
            'CP-P1': [439, 110, 12, 50, 19, 20, 19, 3, 12, 17, 22, 6, 96, 17, 20, 46, 1, 39, 13, 10, 19],
            'CP-P2U-FP': [16, 12, 48, 48, 12, 12, 36, 8, 8, 8, 56, 8, 105, 16, 20, 447, 0, 48, 24, 24, 36],
            'CP-2F': [26, 23, 19, 150, 42, 7, 84, 15, 80, 165, 57, 0, 96, 26, 7, 61, 3, 26, 42, 26, 34],
            'CP-P8': [75, 81, 40, 113, 34, 18, 53, 15, 42, 76, 31, 9, 157, 31, 22, 62, 0, 51, 33, 21, 25],
            'CP-P0': [263, 212, 22, 76, 31, 11, 31, 11, 14, 33, 31, 4, 92, 18, 13, 46, 0, 25, 27, 10, 20],
            'CP-P3U-V': [26, 15, 20, 31, 31, 0, 31, 5, 0, 5, 46, 5, 166, 36, 26, 93, 10, 135, 98, 62, 151],
            'CP-P2U': [18, 22, 18, 45, 20, 6, 22, 15, 4, 13, 31, 9, 279, 45, 58, 119, 6, 112, 51, 42, 56],
            'CP-P3U-FF': [42, 21, 56, 77, 28, 0, 28, 14, 21, 21, 28, 7, 232, 7, 176, 91, 0, 56, 14, 14, 63],
            'CP-SWE-2-V': [40, 38, 126, 65, 36, 16, 46, 12, 15, 33, 148, 24, 70, 13, 12, 60, 1, 37, 22, 27, 148],
            'CP-SWE-2-SW': [39, 39, 138, 58, 34, 21, 43, 12, 14, 30, 165, 27, 71, 12, 12, 57, 1, 49, 22, 116, 31],
            'CP-SWE-2-RW': [40, 39, 140, 59, 37, 16, 45, 12, 14, 31, 167, 27, 70, 15, 12, 57, 1, 36, 116, 26, 30],
            'CP-SWE-2-MB': [38, 36, 123, 57, 32, 18, 41, 11, 14, 28, 147, 24, 76, 15, 12, 66, 1, 160, 22, 37, 32],
            'CP-SWE-2-FP': [39, 39, 106, 64, 35, 15, 44, 11, 13, 30, 126, 21, 72, 14, 12, 232, 0, 41, 20, 24, 32],
            'CP-SWE-2-FF': [41, 40, 149, 61, 37, 18, 45, 13, 15, 31, 176, 29, 75, 11, 95, 55, 0, 31, 20, 23, 26],
            'CP-SWE-2-CS': [39, 39, 149, 59, 36, 17, 44, 13, 14, 30, 178, 29, 74, 78, 13, 59, 1, 38, 24, 25, 30],
            'CP-SWE-2': [47, 46, 95, 80, 28, 14, 40, 11, 12, 38, 110, 17, 288, 10, 12, 51, 0, 32, 15, 19, 24],
            'CP-P9-V': [36, 34, 163, 66, 33, 16, 44, 11, 18, 31, 48, 20, 69, 15, 13, 64, 0, 39, 23, 28, 218],
            'CP-P9-SW': [34, 34, 191, 54, 29, 24, 39, 10, 17, 26, 57, 24, 71, 14, 13, 59, 1, 59, 23, 178, 36],
            'CP-P9-SA': [36, 36, 256, 64, 39, 21, 50, 13, 22, 31, 64, 32, 78, 22, 14, 64, 1, 41, 29, 34, 44],
            'CP-P9-RW': [35, 34, 197, 55, 34, 15, 43, 11, 17, 26, 57, 25, 69, 18, 13, 58, 1, 37, 184, 26, 34],
            'CP-P9-MB': [33, 31, 157, 53, 26, 19, 37, 9, 16, 24, 51, 20, 79, 18, 12, 72, 0, 230, 23, 44, 36],
            'CP-P9-FP': [35, 36, 125, 64, 32, 14, 42, 10, 15, 28, 46, 16, 72, 15, 12, 304, 0, 44, 20, 24, 35],
            'CP-P9-FF': [36, 36, 220, 58, 33, 18, 42, 11, 19, 27, 57, 27, 78, 12, 162, 55, 0, 30, 19, 22, 28],
            'CP-P9-CS': [33, 33, 223, 54, 32, 17, 41, 11, 18, 25, 58, 28, 76, 134, 14, 63, 1, 41, 27, 26, 34],
            'CP-P9': [48, 47, 106, 85, 24, 13, 38, 9, 13, 38, 41, 13, 358, 10, 12, 50, 0, 32, 13, 17, 24],
            'CP-P88': [115, 127, 19, 211, 29, 12, 53, 11, 27, 112, 25, 6, 139, 5, 8, 35, 0, 18, 9, 10, 19],
            'CP-P8-V': [145, 159, 18, 222, 29, 12, 51, 11, 25, 65, 25, 6, 68, 6, 8, 38, 0, 19, 11, 12, 57],
            'CP-P8-SW': [148, 163, 18, 224, 28, 14, 50, 11, 25, 65, 26, 7, 68, 6, 8, 37, 0, 22, 11, 37, 21],
            'CP-P8-SA': [154, 170, 18, 234, 29, 13, 52, 11, 26, 68, 25, 7, 69, 7, 8, 36, 0, 17, 11, 12, 21],
            'CP-P8-RW': [149, 164, 18, 226, 29, 12, 51, 11, 25, 66, 26, 7, 68, 7, 8, 36, 0, 18, 37, 12, 21],
            'CP-P8-MB': [143, 158, 18, 218, 27, 13, 49, 11, 25, 64, 26, 7, 70, 7, 8, 40, 0, 58, 12, 16, 22],
            'CP-P8-FP': [137, 151, 19, 210, 29, 12, 50, 11, 24, 62, 26, 7, 69, 7, 8, 101, 0, 22, 11, 13, 22],
            'CP-P8-FF': [151, 167, 18, 230, 28, 12, 51, 11, 26, 67, 25, 7, 69, 5, 30, 35, 0, 16, 10, 11, 19],
            'CP-P8-CS': [151, 167, 18, 230, 28, 12, 51, 11, 26, 67, 25, 7, 69, 23, 8, 37, 0, 18, 11, 11, 20],
            'CP-P6U-V': [36, 33, 26, 72, 28, 9, 39, 8, 12, 31, 27, 2, 57, 19, 12, 71, 0, 48, 28, 33, 398],
            'CP-P6U-SW': [29, 31, 31, 45, 17, 25, 24, 4, 9, 19, 40, 3, 55, 19, 13, 63, 1, 99, 28, 388, 47],
            'CP-P6U-SA': [34, 33, 30, 80, 44, 10, 49, 10, 16, 34, 37, 5, 59, 72, 17, 99, 2, 88, 73, 84, 114],
            'CP-P6U-RW': [32, 32, 28, 48, 29, 2, 32, 6, 6, 20, 37, 4, 48, 31, 13, 61, 2, 48, 433, 31, 45],
            'CP-P6U-MB': [29, 27, 26, 48, 16, 16, 25, 5, 9, 19, 34, 3, 75, 24, 11, 85, 0, 402, 27, 63, 44],
            'CP-P6U-LC': [16, 33, 29, 48, 24, 3, 33, 7, 9, 31, 39, 3, 29, 29, 1, 48, 460, 33, 54, 26, 31],
            'CP-P6U-FP': [34, 36, 29, 66, 28, 9, 37, 8, 10, 26, 33, 5, 67, 17, 12, 434, 0, 52, 21, 24, 39],
            'CP-P6U-FF': [36, 36, 29, 53, 21, 7, 25, 6, 9, 19, 29, 2, 70, 15, 484, 51, 0, 29, 19, 20, 28],
            'CP-P6U-CY': [214, 214, 0, 71, 0, 0, 0, 0, 0, 0, 0, 0, 0, 71, 0, 142, 0, 214, 0, 0, 71],
            'CP-P6U-CS': [25, 26, 23, 41, 17, 4, 20, 6, 6, 12, 30, 3, 62, 421, 17, 79, 2, 67, 48, 32, 48],
            'CP-P6U': [52, 51, 30, 94, 19, 9, 33, 8, 9, 41, 31, 3, 461, 10, 12, 47, 0, 32, 12, 15, 22],
            'CP-P6H': [408, 172, 20, 78, 16, 13, 21, 6, 7, 19, 30, 8, 77, 6, 9, 36, 0, 19, 11, 12, 21],
            'CP-P6': [179, 345, 21, 86, 27, 15, 36, 10, 9, 27, 31, 9, 78, 6, 9, 40, 0, 18, 12, 13, 20],
            'CP-P5': [195, 99, 26, 87, 18, 10, 28, 7, 8, 32, 31, 5, 306, 8, 11, 43, 0, 27, 12, 14, 22],
            'CP-P4U-V': [36, 33, 26, 72, 28, 9, 39, 8, 12, 31, 27, 2, 57, 19, 12, 71, 0, 48, 28, 33, 398],
            'CP-P4U': [52, 51, 30, 94, 19, 9, 33, 8, 9, 41, 31, 3, 461, 10, 12, 47, 0, 32, 12, 15, 22],
            'CP-P4-V': [220, 243, 21, 81, 24, 13, 33, 9, 9, 25, 30, 8, 74, 8, 10, 44, 0, 23, 14, 16, 83],
            'CP-P4-SW': [229, 254, 22, 78, 22, 15, 30, 8, 9, 24, 32, 8, 75, 7, 10, 42, 0, 28, 14, 59, 23],
            'CP-P4-SA': [248, 275, 21, 83, 24, 14, 32, 9, 9, 25, 31, 9, 77, 9, 10, 41, 0, 21, 14, 16, 24],
            'CP-P4-RW': [232, 257, 21, 79, 24, 13, 31, 8, 8, 24, 31, 8, 74, 9, 10, 41, 0, 21, 59, 15, 23],
            'CP-P4-MB': [216, 239, 21, 77, 22, 14, 30, 8, 9, 23, 31, 8, 77, 9, 10, 47, 0, 87, 14, 22, 24],
            'CP-P4-FP': [198, 219, 23, 79, 25, 13, 33, 9, 9, 25, 31, 8, 75, 9, 10, 144, 0, 27, 14, 16, 25],
            'CP-P4-FF': [239, 265, 21, 81, 23, 13, 31, 9, 9, 24, 30, 8, 77, 7, 48, 40, 0, 19, 12, 13, 21],
            'CP-P4-CY': [296, 257, 20, 82, 21, 14, 29, 8, 8, 23, 30, 9, 77, 6, 9, 38, 0, 18, 12, 12, 20],
            'CP-P4-CS': [240, 266, 21, 80, 23, 13, 30, 9, 8, 23, 30, 8, 77, 37, 10, 42, 0, 22, 14, 14, 22],
            'CP-P3UT-MB': [29, 27, 26, 48, 16, 16, 25, 5, 9, 19, 34, 3, 75, 24, 11, 85, 0, 402, 27, 63, 44],
            'CP-P3UT-RW': [32, 32, 28, 48, 29, 2, 32, 6, 6, 20, 37, 4, 48, 31, 13, 61, 2, 48, 433, 31, 45],
            'CP-P3UT-SW': [29, 31, 31, 45, 17, 25, 24, 4, 9, 19, 40, 3, 55, 19, 13, 63, 1, 99, 28, 388, 47],
            'CP-P3UT-SA': [34, 33, 30, 80, 44, 10, 49, 10, 16, 34, 37, 5, 59, 72, 17, 99, 2, 88, 73, 84, 114],
            'CP-P3UT-LC': [16, 33, 29, 48, 24, 3, 33, 7, 9, 31, 39, 3, 29, 29, 1, 48, 460, 33, 54, 26, 31],
            'CP-P3UT-FF': [36, 36, 29, 53, 21, 7, 25, 6, 9, 19, 29, 2, 70, 15, 484, 51, 0, 29, 19, 20, 28],
            'CP-P3UT-CS': [25, 26, 23, 41, 17, 4, 20, 6, 6, 12, 30, 3, 62, 421, 17, 79, 2, 67, 48, 32, 48],
            'CP-P3UT-FP': [34, 36, 29, 66, 28, 9, 37, 8, 10, 26, 33, 5, 67, 17, 12, 434, 0, 52, 21, 24, 39],
            'CP-P3U-SW': [29, 31, 31, 45, 17, 25, 24, 4, 9, 19, 40, 3, 55, 19, 13, 63, 1, 99, 28, 388, 47],
            'CP-P3U-SA': [34, 33, 30, 80, 44, 10, 49, 10, 16, 34, 37, 5, 59, 72, 17, 99, 2, 88, 73, 84, 114],
            'CP-P3U-RW': [32, 32, 28, 48, 29, 2, 32, 6, 6, 20, 37, 4, 48, 31, 13, 61, 2, 48, 433, 31, 45],
            'CP-P3U-LC': [16, 33, 29, 48, 24, 3, 33, 7, 9, 31, 39, 3, 29, 29, 1, 48, 460, 33, 54, 26, 31],
            'CP-P3U-CS': [25, 26, 23, 41, 17, 4, 20, 6, 6, 12, 30, 3, 62, 421, 17, 79, 2, 67, 48, 32, 48],
            'CP-P3U-MB': [29, 27, 26, 48, 16, 16, 25, 5, 9, 19, 34, 3, 75, 24, 11, 85, 0, 402, 27, 63, 44],
            'CP-P3U-FF': [36, 36, 29, 53, 21, 7, 25, 6, 9, 19, 29, 2, 70, 15, 484, 51, 0, 29, 19, 20, 28],
            'CP-P3U-FP': [34, 36, 29, 66, 28, 9, 37, 8, 10, 26, 33, 5, 67, 17, 12, 434, 0, 52, 21, 24, 39],
            'CP-P3B': [20, 32, 25, 169, 75, 13, 327, 30, 28, 89, 28, 9, 45, 4, 6, 36, 0, 14, 11, 9, 21],
            'CP-P3': [257, 285, 20, 83, 23, 14, 31, 9, 9, 24, 31, 9, 78, 6, 9, 39, 0, 18, 12, 13, 20],
            'CP-P2UE': [50, 49, 39, 85, 26, 11, 38, 10, 9, 39, 120, 12, 342, 10, 11, 50, 0, 33, 14, 18, 23],
            'CP-P2U-V': [36, 33, 26, 72, 28, 9, 39, 8, 12, 31, 27, 2, 57, 19, 12, 71, 0, 48, 28, 33, 398],
            'CP-P2U-SW': [29, 31, 31, 45, 17, 25, 24, 4, 9, 19, 40, 3, 55, 19, 13, 63, 1, 99, 28, 388, 47],
            'CP-P2U-SA': [34, 33, 30, 80, 44, 10, 49, 10, 16, 34, 37, 5, 59, 72, 17, 99, 2, 88, 73, 84, 114],
            'CP-P2U-RW': [32, 32, 28, 48, 29, 2, 32, 6, 6, 20, 37, 4, 48, 31, 13, 61, 2, 48, 433, 31, 45],
            'CP-P2U-MB': [29, 27, 26, 48, 16, 16, 25, 5, 9, 19, 34, 3, 75, 24, 11, 85, 0, 402, 27, 63, 44],
            'CP-P2U-LC': [16, 33, 29, 48, 24, 3, 33, 7, 9, 31, 39, 3, 29, 29, 1, 48, 460, 33, 54, 26, 31],
            'CP-P2U-FF': [36, 36, 29, 53, 21, 7, 25, 6, 9, 19, 29, 2, 70, 15, 484, 51, 0, 29, 19, 20, 28],
            'CP-P2U-CS': [25, 26, 23, 41, 17, 4, 20, 6, 6, 12, 30, 3, 62, 421, 17, 79, 2, 67, 48, 32, 48],
            'CP-P2U-FP': [34, 36, 29, 66, 28, 9, 37, 8, 10, 26, 33, 5, 67, 17, 12, 434, 0, 52, 21, 24, 39],
            'CP-P2H': [408, 172, 20, 78, 16, 13, 21, 6, 7, 19, 30, 8, 77, 6, 9, 36, 0, 19, 11, 12, 21],
            'CP-P2F': [33, 35, 14, 431, 36, 11, 78, 15, 49, 125, 17, 5, 59, 4, 5, 30, 0, 13, 7, 7, 17],
            'CP-P28-V': [28, 30, 15, 323, 36, 11, 73, 14, 44, 187, 19, 4, 55, 5, 6, 33, 0, 17, 10, 10, 70],
            'CP-P28-SA': [27, 30, 14, 353, 38, 11, 77, 15, 48, 206, 19, 5, 55, 6, 5, 29, 0, 14, 9, 10, 20],
            'CP-P28-MB': [27, 30, 15, 316, 34, 12, 70, 13, 43, 183, 20, 4, 58, 6, 6, 36, 0, 70, 10, 15, 21],
            'CP-P28-LC': [26, 30, 14, 362, 37, 11, 78, 15, 49, 211, 18, 5, 55, 3, 5, 27, 2, 12, 7, 7, 16],
            'CP-P28-FP': [28, 31, 17, 296, 35, 10, 69, 13, 40, 170, 21, 5, 58, 6, 6, 119, 0, 21, 10, 11, 22],
            'CP-P28-CS': [26, 30, 14, 343, 36, 10, 74, 14, 46, 200, 19, 5, 56, 29, 5, 30, 0, 15, 9, 8, 18],
            'CP-P12U': [52, 51, 30, 94, 19, 9, 33, 8, 9, 41, 31, 3, 461, 10, 12, 47, 0, 32, 12, 15, 22],
            'CP-P10-V': [33, 34, 16, 359, 34, 11, 70, 13, 42, 106, 19, 4, 58, 7, 7, 38, 0, 20, 11, 12, 93],
            'CP-P10-SW': [32, 34, 16, 374, 33, 13, 70, 13, 43, 109, 21, 5, 58, 6, 6, 34, 0, 25, 10, 64, 22],
            'CP-P10-SA': [33, 35, 15, 412, 36, 11, 77, 14, 47, 120, 18, 5, 59, 7, 6, 33, 0, 16, 10, 11, 22],
            'CP-P10-RW': [33, 34, 16, 379, 35, 10, 72, 14, 43, 111, 20, 5, 57, 7, 6, 34, 0, 17, 65, 11, 21],
            'CP-P10-MB': [32, 33, 16, 349, 32, 12, 67, 12, 41, 102, 21, 5, 62, 8, 7, 41, 0, 96, 11, 19, 23],
            'CP-P10-LC': [33, 35, 14, 428, 36, 11, 78, 15, 49, 124, 18, 5, 59, 4, 5, 30, 3, 13, 7, 7, 18],
            'CP-P10-FP': [33, 35, 19, 318, 33, 10, 65, 13, 37, 94, 22, 5, 61, 8, 7, 155, 0, 25, 11, 12, 24],
            'CP-P10-FF': [33, 35, 15, 394, 34, 11, 73, 14, 45, 114, 19, 5, 60, 5, 52, 32, 0, 14, 8, 9, 18],
            'CP-P10-CY': [33, 35, 14, 431, 36, 11, 78, 15, 49, 125, 17, 5, 59, 4, 5, 30, 0, 13, 7, 7, 17],
            'CP-P10-CS': [32, 34, 15, 395, 34, 10, 73, 14, 45, 114, 19, 5, 59, 42, 6, 34, 0, 18, 11, 10, 20],
            'CP-CE-6': [47, 45, 59, 64, 42, 17, 48, 15, 10, 37, 324, 31, 71, 11, 11, 55, 1, 33, 21, 25, 24],
            'CP-CE-3': [47, 45, 59, 64, 42, 17, 48, 15, 10, 37, 324, 31, 71, 11, 11, 55, 1, 33, 21, 25, 24],
            'CP-CE-2': [47, 45, 59, 64, 42, 17, 48, 15, 10, 37, 324, 31, 71, 11, 11, 55, 1, 33, 21, 25, 24],
            'CP-6F': [33, 35, 14, 431, 36, 11, 78, 15, 49, 125, 17, 5, 59, 4, 5, 30, 0, 13, 7, 7, 17],
            'CP-6B': [20, 32, 25, 169, 75, 13, 327, 30, 28, 89, 28, 9, 45, 4, 6, 36, 0, 14, 11, 9, 21],
            'CP-3F': [33, 35, 14, 431, 36, 11, 78, 15, 49, 125, 17, 5, 59, 4, 5, 30, 0, 13, 7, 7, 17],
            'CP-3B': [20, 32, 25, 169, 75, 13, 327, 30, 28, 89, 28, 9, 45, 4, 6, 36, 0, 14, 11, 9, 21],
            'CP-2B': [20, 32, 25, 169, 75, 13, 327, 30, 28, 89, 28, 9, 45, 4, 6, 36, 0, 14, 11, 9, 21],
            'CP-22': [33, 35, 14, 431, 36, 11, 78, 15, 49, 125, 17, 5, 59, 4, 5, 30, 0, 13, 7, 7, 17],
            'CP-21': [15, 21, 13, 236, 40, 10, 78, 15, 48, 377, 19, 4, 48, 2, 4, 22, 0, 9, 6, 6, 15],
            'CP-P37': [15, 21, 13, 236, 40, 10, 78, 15, 48, 377, 19, 4, 48, 2, 4, 22, 0, 9, 6, 6, 15],
        },
        // DO NOT EDIT skuKey, edit OOS_SKU_REPLACEMENTS to hide items from component
        skuKey: [
            'CP-01', // 0
            'CP-02', // 1
            'CP-10-15', // 2
            'CP-11', // 3
            'CP-12F', // 4
            'CP-12M', // 5
            'CP-13', // 6
            'CP-14', // 7
            'CP-16-15', // 8
            'CP-17', // 9
            'CP-CE-1', // 10
            'CP-CU-KITC', // 11
            'CP-UA', // 12
            'CP-UA-CS', // 13
            'CP-UA-FF', // 14
            'CP-UA-FP', // 15
            'CP-UA-LC', // 16
            'CP-UA-MB', // 17
            'CP-UA-RW', // 18
            'CP-UA-SP', // 19
            'CP-UA-SW', // 20
        ],
    };

    // Get currency symbol based on hostname
    function getCurrencySymbol() {
        if (window.location.hostname.includes('uk.')) {
            return '£';
        } else if (
            window.location.hostname.includes('de.') ||
            window.location.hostname.includes('fr.') ||
            window.location.hostname.includes('nl.')
        ) {
            return '€';
        } else {
            return '$';
        }
    }

    /**
     * RecommendationEngine
     * Pure logic for calculating product recommendations based on cart contents
     */
    class RecommendationEngine {
        constructor(skuMatrix, skuKey, baseRecommendation, skuOverrides = {}, scentRecommendations = null) {
            this.skuMatrix = skuMatrix;
            this.skuKey = skuKey;
            this.baseRecommendation = baseRecommendation;
            this.skuOverrides = skuOverrides;
            this.scentPicks = scentRecommendations?.scentPicks || {};
            this.pairPicks = scentRecommendations?.pairPicks || {};
        }

        calculate(cartSkus) {
            // Underarm scents not live on site are ignored entirely
            const skus = (cartSkus || []).filter((sku) => !sku.startsWith('CP-UA') || this.scentPicks[sku]);
            const recommendedSku = this.calculateForScents(skus) || this.calculateFromMatrix(skus);

            // Apply substitution if SKU has an override
            return this.skuOverrides[recommendedSku]?.substituteWith || recommendedSku;
        }

        calculateForScents(cartSkus) {
            // Single-scent packs (CP-P3U-CV, CP-P10-CV...) count as their scent
            const scents = [...new Set(cartSkus.map((sku) => sku.replace(/^CP-P\w*-([A-Z]{2})$/, 'CP-UA-$1')))]
                .filter((sku) => this.scentPicks[sku])
                .sort();

            const pairPick = scents.length === 2 && this.pairPicks[scents.join('|')];
            if (pairPick) {
                return pairPick;
            }

            // Each scent votes for its first pick not in the cart; the base recommendation wins ties,
            // otherwise the first voter's pick
            const votes = {};
            scents.forEach((scent) => {
                const pick = this.scentPicks[scent].find((sku) => !scents.includes(sku));
                if (pick) {
                    votes[pick] = (votes[pick] || 0) + 1;
                }
            });
            const mostVotes = Math.max(...Object.values(votes));
            const tied = Object.keys(votes).filter((sku) => votes[sku] === mostVotes);
            return tied.includes(this.baseRecommendation) ? this.baseRecommendation : tied[0];
        }

        // Carts with no live scent (hand, foot, body...) keep the original matrix logic
        calculateFromMatrix(cartSkus) {
            if (cartSkus.length === 0) {
                return this.baseRecommendation;
            }

            const preferences = [];

            // Build preferences array for each cart SKU
            for (let j = 0; j < cartSkus.length; j++) {
                if (this.skuMatrix[cartSkus[j]]) {
                    preferences[j] = this.skuMatrix[cartSkus[j]];
                }
            }

            // Filter out undefined entries
            const filteredPreferences = preferences.filter((item) => item);

            // Build master array by summing all preference arrays
            const masterArray = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
            for (let l = 0; l < filteredPreferences.length; l++) {
                for (let p = 0; p < filteredPreferences[l].length; p++) {
                    masterArray[p] += filteredPreferences[l][p];
                }
            }

            // Zero out any SKUs already in cart, and underarm scents not live on site
            this.skuKey.forEach((sku, q) => {
                if (cartSkus.includes(sku) || (sku.startsWith('CP-UA') && !this.scentPicks[sku])) {
                    masterArray[q] = 0;
                }
            });

            // Find max value and its index
            let maxIndex = 0;
            let maxNum = 0;
            for (let y = 0; y < masterArray.length; y++) {
                if (masterArray[y] > maxNum) {
                    maxNum = masterArray[y];
                    maxIndex = y;
                }
            }

            if (maxNum === 0) {
                return this.baseRecommendation;
            }

            return this.skuKey[maxIndex];
        }
    }

    /**
     * PricingCalculator
     * Handles discount tier logic and price calculations
     */
    class PricingCalculator {
        constructor(currency) {
            this.currency = currency;
        }

        calculate(params) {
            const { cartItems, productPrice, variantId, hasSubscription } = params;

            let discountData = {
                tier: null,
                percentage: null,
                originalPrice: productPrice,
                finalPrice: productPrice,
                showFlag: true,
            };

            // Calculate running_unit_total from cart items
            // This matches the Ruby script logic
            let runningUnitTotal = 0;

            if (cartItems && Array.isArray(cartItems)) {
                cartItems.forEach((item) => {
                    // Prefer bundle_items_total, fall back to item_total, default to "1"
                    const itemTotal = item.properties?.bundle_items_total ||
                        item.properties?.item_total ||
                        "1";
                    runningUnitTotal += item.quantity * parseFloat(itemTotal);
                });
            }

            // Capture actual item count before subscription boost (for A/B test)
            const actualItemCount = runningUnitTotal;

            // Add subscription boost if cart has subscription items
            if (hasSubscription === true) {
                runningUnitTotal += 2;
            }

            // Add 1 for the upsell product being forecasted
            const forecastedTotal = runningUnitTotal + 1;

            // A/B Test: Override to 25% when reduced UA pricing applies (1-2 UA sticks)
            const hasTestVariantProperty = cartItems?.some((item) =>
                item.properties?._reduced_ua_pricing_test_variant === "true" ||
                item.properties?._reduced_ua_pricing_test_variant === true
            ) ?? false;
            const abTestApplies = (window.reducedUAPricing === true ||
                hasTestVariantProperty) &&
                actualItemCount >= 1 &&
                actualItemCount <= 2;

            if (abTestApplies) {
                discountData.percentage = 25;
                discountData.tier = '25%';
                discountData.finalPrice = Math.round(productPrice * 0.75);
            } else if (forecastedTotal >= 6) {
                // 30% off
                discountData.percentage = 30;
                discountData.tier = '30%';
                discountData.finalPrice = Math.round(productPrice * 0.7);
            } else if (forecastedTotal >= 5) {
                // 25% off
                discountData.percentage = 25;
                discountData.tier = '25%';
                discountData.finalPrice = Math.round(productPrice * 0.75);
            } else if (forecastedTotal >= 3) {
                // 20% off
                discountData.percentage = 20;
                discountData.tier = '20%';
                discountData.finalPrice = Math.round(productPrice * 0.8);
            } else if (forecastedTotal >= 2) {
                // 15% off
                discountData.percentage = 15;
                discountData.tier = '15%';
                discountData.finalPrice = Math.round(productPrice * 0.85);
            } else {
                // No discount (< 2)
                discountData.showFlag = false;
            }

            return discountData;
        }

        formatPrice(cents) {
            return this.currency + (cents / 100).toFixed(2);
        }
    }

    /**
     * CartUpsell
     * Main component managing state and DOM updates
     */
    class CartUpsell {
        constructor(config) {
            this.config = config;
            this.currency = getCurrencySymbol();

            this.state = {
                cart: null,
                recommendedSku: null,
                recommendedProduct: null,
                recommendedVariant: null,
                isUAVariant: false,
                discountData: null,
                isInflight: false,
            };

            this.elements = {};

            this.recommendationEngine = new RecommendationEngine(
                config.skuMatrix,
                config.skuKey,
                config.baseRecommendation,
                config.skuOverrides || {},
                config.scentRecommendations
            );

            this.pricingCalculator = new PricingCalculator(this.currency);
        }

        cacheElements() {
            this.elements.container = document.getElementById('cart-drawer-cross-sell-container');
            if (!this.elements.container) {
                console.warn('Cart drawer cross sell container not found');
                return;
            }
            this.elements.cardContainer = this.elements.container.querySelector('[data-cart-drawer-cross-sell-card-container]');
            if (!this.elements.cardContainer) {
                console.warn('Cart drawer cross sell card container not found');
            }
        }

        async init() {
            // Validate required globals exist
            if (!window.carpe_variants) {
                console.error('[CartUpsell] window.carpe_variants is not defined');
                return;
            }
            if (!window.carpe_products) {
                console.error('[CartUpsell] window.carpe_products is not defined');
                return;
            }

            this.cacheElements();
            this.setupEventListeners();
            await this.fetchCart();
        }

        setupEventListeners() {
            // Use event delegation on the card container to handle button clicks
            // This ensures the handler works even when DOM is regenerated by updateDOM()
            if (this.elements.cardContainer) {
                this.elements.cardContainer.addEventListener('click', (event) => {
                    const button = event.target.closest('#cart-drawer-cross-sell-submit-button, .js-add-to-cart-submit');
                    if (button) {
                        this.addCrossSellItemToCart(event);
                    }
                });
            }
        }

        async fetchCart() {
            try {
                const response = await fetch('/cart.js');
                this.state.cart = await response.json();

                if (!this.state.cart || !this.state.cart.items) {
                    console.error('[CartUpsell] Invalid cart data received');
                    return;
                }

                this.calculateRecommendation();
            } catch (error) {
                console.error('[CartUpsell] Cart fetch error:', error);
            }
        }

        calculateRecommendation() {
            const items = this.state.cart.items;
            const cartSkus = items.map((item) => item.sku);

            // Get recommended SKU
            this.state.recommendedSku = this.recommendationEngine.calculate(cartSkus);

            // Look up variant and product
            let found = false;
            for (const key in window.carpe_variants) {
                if (key === this.state.recommendedSku) {
                    this.state.recommendedVariant = window.carpe_variants[key];

                    if (key.indexOf('CP-UA') !== -1) {
                        this.state.recommendedProduct = window.carpe_products['CP-UA'];
                        this.state.isUAVariant = true;
                    } else {
                        this.state.recommendedProduct = window.carpe_products[key];
                        this.state.isUAVariant = false;
                    }
                    found = true;
                    break;
                }
            }

            // Validate we found the recommended product
            if (!found) {
                console.error(`[CartUpsell] Recommended SKU "${this.state.recommendedSku}" not found in window.carpe_variants`);
                return;
            }

            if (!this.state.recommendedProduct) {
                console.error(`[CartUpsell] Product data not found for SKU "${this.state.recommendedSku}"`);
                return;
            }

            if (!this.state.recommendedVariant) {
                console.error(`[CartUpsell] Variant data not found for SKU "${this.state.recommendedSku}"`);
                return;
            }

            this.calculateDiscount();
        }

        calculateDiscount() {
            const hasSubscription = this.hasSubscriptionInCart();

            this.state.discountData = this.pricingCalculator.calculate({
                cartItems: this.state.cart.items,
                productPrice: this.state.recommendedProduct.price,
                variantId: this.state.recommendedVariant.id,
                hasSubscription: hasSubscription,
            });

            this.updateDOM();
        }

        hasSubscriptionInCart() {
            return this.state.cart.items.some((item) => {
                return item.selling_plan_allocation && item.selling_plan_allocation.selling_plan.id;
            });
        }

        async addCrossSellItemToCart(event) {
            // Prevent default reload action so ATC works on Cart & Drawer
            event.preventDefault();

            if (this.state.isInflight) {
                return;
            }
            this.state.isInflight = true;

            const button = event.target.closest('#cart-drawer-cross-sell-submit-button, .js-add-to-cart-submit');
            if (!button) {
                console.error('Button element not found');
                return;
            }

            const cartItemData = {
                id: button.dataset.productId,
                quantity: 1,
            };

            // Add selling plan if subscription order
            if (this.hasSubscriptionInCart() && button.dataset.sellingPlanId) {
                cartItemData.selling_plan = button.dataset.sellingPlanId;
            }

            // A/B Test: Add _reduced_ua_pricing_test_variant property for UA product when reducedUAPricing flag is set
            if (window.reducedUAPricing === true && this.state.recommendedProduct?.id === UA_PRODUCT_ID_AB_TEST) {
                cartItemData.properties = cartItemData.properties || {};
                cartItemData.properties._reduced_ua_pricing_test_variant = cartItemData.selling_plan ? "true" : "otp";
            }

            button.dataset.isLoading = true;
            button.classList.add('sub-button--loading')

            try {
                const response = await fetch('/cart/add.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(cartItemData),
                });

                if (!response.ok) {
                    throw new Error(`Failed to add item to cart: ${response.statusText}`);
                }

                // Trigger conversion tracking
                window._conv_q = window._conv_q || [];
                window._conv_q.push(["triggerConversion", "100323219"]);

                // Show toast notification
                this.showToast();

                // Don't refresh the page if on the cart page
                if (window.location.href.includes("/cart")) {
                    location.reload();
                    return;
                }

                // Refresh the cart drawer
                if (window.CartDrawer?.refreshDrawer) {
                    await window.CartDrawer.refreshDrawer();
                } else {
                    const drawerResponse = await fetch("/?section_id=cart-drawer");
                    const drawerHTML = await drawerResponse.text();
                    const drawerElement = document.getElementById("offcanvas-cart-drawer");
                    if (drawerElement) {
                        drawerElement.innerHTML = drawerHTML;
                    }
                    document.dispatchEvent(new Event("refreshCart", { bubbles: true }));
                }
            } catch (error) {
                console.error("Error adding item to cart:", error);
            } finally {
                button.dataset.isLoading = false;
                button.classList.remove('sub-button--loading')
                this.state.isInflight = false;
            }
        }

        updateDOM() {
            const { recommendedProduct, recommendedVariant, isUAVariant, discountData } = this.state;

            // Safety check before rendering
            if (!recommendedProduct || !recommendedVariant || !discountData) {
                console.warn('[CartUpsell] Cannot render: missing product, variant, or discount data');
                return;
            }

            const productUrl = `/products/${recommendedProduct.handle}`;
            const imageUrl = isUAVariant ? recommendedVariant.featured_image : recommendedProduct.featured_image;
            const surface = this.elements.container.closest('#cartDrawerContainer') ? 'drawer' : 'cart-page';

            // Build variant title HTML (only for UA variants)
            const variantTitleHTML = isUAVariant
                ? `<a class="cart-drawer-cross-sell__variantTitle" href="${productUrl}">${recommendedVariant.title}</a>`
                : '';

            const savePillHTML = discountData.showFlag
                ? `<div class="cart-drawer-cross-sell__save-pill">Save <strong>${discountData.percentage}%</strong></div>`
                : '';

            const comparePriceHTML = discountData.showFlag
                ? `<del class="cart-drawer-cross-sell__compareprice">${this.pricingCalculator.formatPrice(discountData.originalPrice)}</del>`
                : '';

            this.elements.cardContainer.innerHTML = `
                <a class="cart-drawer-cross-sell__imageLink" href="${productUrl}">
                    <img class="cart-drawer-cross-sell__imagePlaceholder"
                        src="${imageUrl}&width=128"
                        width="64"
                        height="64">
                </a>

                <div class="cart-drawer-cross-sell__info">
                    ${savePillHTML}
                    <a class="cart-drawer-cross-sell__product-title" href="${productUrl}">${recommendedProduct.title}</a>
                    ${variantTitleHTML}
                    <div class="cart-drawer-cross-sell__price-container">
                        ${comparePriceHTML}
                        <div class="cart-drawer-cross-sell__price">${this.pricingCalculator.formatPrice(discountData.finalPrice)}</div>
                    </div>
                </div>

                <button type="submit"
                        id="cart-drawer-cross-sell-submit-button"
                        class="js-add-to-cart-submit cart-drawer-cross-sell__atc-button"
                        aria-label="Add to cart"
                        data-convert-cart-cross-sell-atc="${surface}"
                        data-product-id="${recommendedVariant.id}"
                        data-selling-plan-id="${recommendedVariant.selling_plan_allocations?.[0]?.selling_plan_id || ''}">
                    <span>ADD +</span>
                </button>
            `;


        }

        showToast() {
            // Remove existing toast if present
            const existingToast = document.getElementById('cart-drawer-cross-sell-toast');
            if (existingToast) {
                existingToast.remove();
            }

            // Create toast element using template literal
            const toastHTML = `
                <div id="cart-drawer-cross-sell-toast" class="cart-drawer-cross-sell__toast-container">
                    Added to Cart!
                </div>
            `;

            // Append to document body
            document.body.insertAdjacentHTML('beforeend', toastHTML);

            // Get reference to the newly created toast element
            const toast = document.getElementById('cart-drawer-cross-sell-toast');
            if (!toast) return;

            // Remove after 5 seconds
            setTimeout(() => {
                toast.remove();
            }, 5000);

            // close on click 
            toast.addEventListener('click', () => {
                toast.remove();
            });
        }
    }

    // Initialize component
    let cartUpsellInstance = null;

    // Only expose what's needed
    window.cartUpsell = function () {
        if (!cartUpsellInstance) {
            cartUpsellInstance = new CartUpsell(CART_UPSELL_DATA);
        }
        cartUpsellInstance.init();
    };

    // Auto-initialize
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', window.cartUpsell);
    } else {
        window.cartUpsell();
    }
})();
